import { z } from "zod";
/** `GET /api/me/privacy` (review 0016): a waiting deletion and the leaderboard preference. */
export const privacyStatusSchema = z.object({
    /** When the waiting deletion runs; null when none waits (decision 88). */
    deletionDueAt: z.number().int().nullable(),
    hideOnLeaderboard: z.boolean(),
    /** False once the player objected to usage measurement (decision 206); a server before it says nothing. */
    measurement: z.boolean().default(true),
});
/** `POST /api/me/export`: a one-time link, opened in the browser outside Discord (decision 89). */
export const exportLinkSchema = z.object({ url: z.string().url() });
//# sourceMappingURL=privacy.js.map